<template>
  <div>
    <b-overlay :show="loading">
      <main-title title="Novedades" />
      <div class="d-flex" style="margin: 0px -1rem;">
        <big-new :data="novedades[0]"></big-new>
      </div>
      <div class="row" style="margin: 1rem -1rem;">
        <div class="col-4">
          <small-news :data="novedades[1]"></small-news>
        </div>
        <div class="col-4">
          <small-news :data="novedades[2]"></small-news>
        </div>
        <div class="col-4">
          <small-news :data="novedades[3]"></small-news>
        </div>
      </div>
      <div class="d-flex" style="margin: 1rem -1rem;">
        <micro-news order="1"></micro-news>
        <micro-news order="2"></micro-news>
        <micro-news order="3"></micro-news>
      </div>
      <div class="row" style="margin: 1rem -1rem;">
        <div class="col-4">
          <small-news :data="novedades[4]"></small-news>
        </div>
        <div class="col-4">
          <small-news :data="novedades[5]"></small-news>
        </div>
        <div class="col-4">
          <small-news :data="novedades[6]"></small-news>
        </div>
      </div>
      <!--<div class="text-center my-3 pt-3">
        <b-button class="w-50">Ver más</b-button>
      </div>-->
    </b-overlay>
  </div>
</template>
<script>
import MainTitle from "@/components/MainTitle.vue";
import SmallNews from "@/components/Noticias/Small.vue";
import MicroNews from "@/components/Noticias/Micro.vue";
import BigNew from "@/components/Noticias/BigNew.vue";
import axios from "axios";

export default {
  components: {
    MainTitle,
    SmallNews,
    MicroNews,
    BigNew
  },
  data() {
    return {
      novedades: [],
      loading: true
    }
  },
  mounted(){
    this.updatenews();
  },
  methods:{
    async updatenews(){
      console.log(this.$store.state.user.siteData);

      this.novedades = await axios
        .post(
          this.$store.state.user.siteData.location + "news/news/getAll",
          JSON.stringify({type: 'list'}),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          this.loading = false;
          const records = evtResponse.data.records; 
          return records;
        });
    },
  }
};
</script>
